import { LitElement, html, css } from "lit";
import "../lazy-image/lazy-image"
import "./push-article.css"

export class PushArticle extends LitElement {

    static properties = {
        title: { type: String },
        more: { type: String },
        img: { type: String },
        link: { type: String },
        imgAlt: { type: String }
    }

    static styles = css`
    :host{
        display: block;
        max-width: 400px;
        display : flex;
    }

    .wrapper{
        padding: 15px;
    }

    .txt{
        padding-left: 20px ;
    }
    
    .title{
        font-size: 24px;
        margin-bottom: .5em;
    }
    
    .intro {
        font-size: 16px;
        line-height: 1.8em;
        margin-bottom : 1em;
    }
    `

    render() {
        return html`
            <div class="wrapper">
                <div class="img">
                    <lazy-image src="${this.img}"></lazy-image>
                </div>
                <div class="txt">
                    <h2 class="title">${this.title}</h2>
                    <div class="intro">
                        <slot></slot>
                    </div>
                    <div class="more">
                        <a href=${this.link}>${this.more}</a>
                    </div>
            
                </div>
            </div>`
    }
}

customElements.define('push-article', PushArticle);